import { DownloadExcelButtonProps } from "@vocollege/components/dist/DownloadExcelButton";

export const getExcelData = (
  data: any,
  parsedData: any,
  variables: any,
  dataCategory: string,
  label: string
) => {
  if (parsedData.length === 0) {
    return null;
  }
  const result: DownloadExcelButtonProps = {
    filename: label.toLowerCase().replaceAll(" ", "_"),
    sheets: [],
  };

  let commonHead = [
    [
      {
        richText: [
          {
            font: {
              size: 16,
              bold: true,
            },
            text: label,
          },
        ],
      },
      "",
      "TEST",
    ],
  ];

  result.sheets?.push({ name: label, rows: [...commonHead] });

  return result;
};
